import React from 'react'

const Footer = () => {
  return (
    <section className='footer'>
        <a href='/'>Crafted by Reaz Ahammed Chowdhury</a>
    </section>
  )
}

export default Footer